import * as React from 'react';
import { ArticleHeading5, Button, Tooltip } from '@cian/ui-kit';
import { IPhoneButtonProps } from '../types';
import * as styles from './PhoneButtonDesktop.css';
import { InteractiveElementsWrapper } from '../../InteractiveElementsWrapper';

export const PhoneButtonDesktop: React.FC<IPhoneButtonProps> = ({ phone, collapsedPhone, phoneVisible, onClick }) => {
  return (
    <div className={styles['container']}>
      {phoneVisible ? (
        <ArticleHeading5 display="inline-block" data-name="BuilderPhone">
          {phone}
        </ArticleHeading5>
      ) : (
        <Tooltip title="Показать телефон" header="На кнопке" placement="left">
          <InteractiveElementsWrapper>
            <Button data-name="BuilderPhoneButton" size="XS" theme="fill_primary" fullWidth onClick={onClick}>
              {collapsedPhone}
            </Button>
          </InteractiveElementsWrapper>
        </Tooltip>
      )}
    </div>
  );
};
